// extracted by mini-css-extract-plugin
export default {"songContainer":"play-state_songContainer__pJdz0","buttonsContainer":"play-state_buttonsContainer__IoGYR"};